import styled from 'styled-components';
import { Button } from 'src/components/widgets/buttons';
import { Icon } from 'src/components/widgets/icon';
import Stack from 'src/components/widgets/stack/stack';

// Container principale. Niente card: sta già dentro la dialog delle Settings, che ha il suo
// bordo e il suo margine — una seconda cornice con l'ombra era una finestra dentro la finestra.
export const Container = styled(Stack).attrs({ $gap: '20px' })``;

// Sezione generica: il passo fra una e l'altra lo tiene il Container.
export const Section = styled.div``;

// Header espandibile per Action Button
export const ActionButtonHeader = styled.button<{ $isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 6px;
    font-family: inherit;
    font-size: 13px;
    color: ${(props) => props.theme.app.textColor};
    text-align: left;
    cursor: pointer;
    background-color: ${(props) => (props.$isOpen ? props.theme.app.pageBackgroundColor : props.theme.app.backgroundColor)};
    transition: background-color 0.2s;

    &:hover {
        background-color: ${(props) => props.theme.app.pageBackgroundColor};
    }
`;

// Freccia dell'header espandibile
export const ExpandIcon = styled(Icon)<{ $isOpen: boolean }>`
    transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s;
`;

// Pannello customizzazioni
export const CustomizationPanel = styled.div`
    padding: 4px 12px;
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 6px;
`;

// Container per icon image
export const IconImageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

// Area preview dell'icona
export const IconPreview = styled.div`
    width: 40px;
    height: 40px;
    margin-right: 4px;
    border: 1px dashed ${(props) => props.theme.app.borderColor};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Immagine dell'icona
export const IconImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

// Placeholder per l'icona
export const IconPlaceholder = styled.span`
    font-size: 11px;
    color: ${(props) => props.theme.app.primary};
`;

// Container per text label con reset
export const TextLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    width: 240px;
`;

// Preview del bottone
export const ButtonPreview = styled.div<{
    backgroundColor: string;
    textColor: string;
    borderSize: string;
    borderColor: string;
    borderRadius: string;
}>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    border: ${(props) => props.borderSize} solid ${(props) => props.borderColor};
    border-radius: ${(props) => props.borderRadius};
`;

// Icona nel preview del bottone
export const PreviewIcon = styled.img`
    width: 16px;
    height: 16px;
`;

// Note informative
export const InfoNote = styled.div`
    margin-top: 10px;
    font-size: 12px;
    color: ${(props) => props.theme.app.primary};
`;

// La casella che dipende da quella sopra ci sta sotto, un passo più in dentro.
export const IndentedOption = styled.div`
    margin-left: 24px;
`;

// Tre comandi in fila: se la colonna è stretta vanno a capo invece di uscire dal bordo.
// E FormControl allarga a tutta riga ogni bottone che contiene: qui stanno alla loro misura.
export const ReferenceActions = styled(Stack)`
    flex-wrap: wrap;

    &&& ${Button} {
        width: auto;
    }
`;
